import styled from 'styled-components';
import devices from '../../common/styles/devices';

const NewLine = styled('br')`
  display: none;

  @media ${devices.mobileL} {
    display: block;
  }
`;

export default NewLine;
